module.exports = "https://r.zoocdn.com/_next/static/images/prices-f3ff6b8e5fd9aa0031efb1abc4cff499.svg";